// extracted by mini-css-extract-plugin
export var searchHeader = "_5j-0";
export var searchHeaderDark = "_5j-1";